import { observable, action, computed, runInAction } from "mobx";
import { noBranchSelectedBranch } from "../constants/constants-container";
import ActorUtils from "src/utils/ActorUtils";

const IS_BIRD_APP = process.env.REACT_APP_ENV === "bird";

export default class DictionaryAdministratorStore {
  @observable
  obj_dictionaryAdministratorData = {
    maintenanceAgencies: []
  };

  @observable selectedBranchData = {
    mid: "",
    pid: "",
    bid: ""
  }

  @observable bool_showCreateBranchModal = false;

  @observable
  obj_createBranchModalData = {
    maintenanceAgencyName: "",
    maintenanceAgencyId: "",
    projects: [],
    project: {
      branches: null,
      project: null,
      framework: null,
      frameworks: null,
    },
    projectId: "",
    branchName: "",
    description: "",
    dictionaryAdministrators: []
  };

  constructor(http, userStore, contentManagementStore) {
    this.http = http;
    this.userStore = userStore;
    this.contentManagementStore = contentManagementStore;
  }

  @action
  activate_DaStore = () => {
    this.func_fetchDictionaryAdministratorData();
  };

  @action
  selectBranch = (maintenanceAgencyId, projectId, branchId) => {
    this.selectedBranchData = {
      mid: maintenanceAgencyId,
      pid: projectId,
      bid: branchId
    }
  }

  @action
  func_fetchDictionaryAdministratorData = () => {
    if(IS_BIRD_APP) return;
    
    this.http.fetch_dictionary_administrator_data().then(
      action(data => {
        if (data) {
          this.obj_dictionaryAdministratorData = data;
          const { maintenanceAgencies } = this.obj_dictionaryAdministratorData;
          if (maintenanceAgencies && maintenanceAgencies.length > 0) {
            this.func_resetSettings();
            const { func_restoreSelectedBranchFromLocalStorageIfStillExists } = this.contentManagementStore;
            func_restoreSelectedBranchFromLocalStorageIfStillExists(
              this.obj_dictionaryAdministratorData.maintenanceAgencies,
              () => this.selectBranch("", "", "")
            );
          }
        }
      })
    );
  };

  @action
  func_sendRequest = (jsonToSend, callback) => {
    if(IS_BIRD_APP) return;
    
    runInAction(() => {
      this.http.func_sendGeneralMessage(jsonToSend, response => {
        if (
          response &&
          response.resultType &&
          response.resultType === "SUCCESS"
        ) {
          if(callback) {
            callback();
          }
        }
      });
    });
  };

  @action
  func_toggleCreateBranchModalVisibility = () => {
    this.func_resetSettings();
    this.bool_showCreateBranchModal = !this.bool_showCreateBranchModal;
  };

  func_getDefaultProject = () => {
    const maintenanceAgenciesWithOpenProject = this.getMaintenanceAgenciesWithOpenProject;
    if (maintenanceAgenciesWithOpenProject[0].projects.length > 0) {
      const openProjects = maintenanceAgenciesWithOpenProject[0].projects.filter(projectItem => projectItem.project.status === "OPEN");
      return openProjects.length > 0 ? openProjects[0] : {};
    }
    return {};
  };

  func_getDefaultProjectId = () => {
    let defaultProject = this.func_getDefaultProject();
    if (defaultProject !== {}) {
      return defaultProject.project.tid;
    }
    return "";
  };

  func_getMaintenanceAgencyIdByName = maintenanceAgencyName => {
    let { maintenanceAgencies } = this.get_obj_dictionaryAdministratorData;
    const filteredResults = maintenanceAgencies.filter(
      item =>
        item.maintenanceAgency.name === maintenanceAgencyName
    );
    return filteredResults.length === 1
      ? filteredResults[0].maintenanceAgency.tid
      : "";
  };

  func_constructJson() {
    let jsonToSend = {
      actionType: "CreateBranch",
      branch: {
        mid: this.obj_createBranchModalData.maintenanceAgencyId,
        pid: this.obj_createBranchModalData.projectId,
        name: this.obj_createBranchModalData.branchName,
        description: this.obj_createBranchModalData.description,
      },
      dictionaryAdministrators: [this.userStore.get_obj_userData.actor.tid]
    };

    return jsonToSend;
  }

  @action
  func_handleProjectSelectionChange = selectedProjectName => {
    let selectedProject = this.obj_createBranchModalData.projects.filter(
      item => item.project.name === selectedProjectName
    )[0];
    this.obj_createBranchModalData = {
      ...this.obj_createBranchModalData,
      project: selectedProject,
      projectId: selectedProject.project.tid
    };
  };

  @action
  func_handleMaintenanceAgencyNameChange = maintenanceAgencyName => {
    let tid = this.func_getMaintenanceAgencyIdByName(maintenanceAgencyName);
    this.obj_createBranchModalData = {
      ...this.obj_createBranchModalData,
      maintenanceAgencyName: maintenanceAgencyName,
      maintenanceAgencyId: tid
    };
    this.func_getProjectsByMaintenanceAgency();
  };

  @action
  func_getProjectsByMaintenanceAgency = () => {
    let { maintenanceAgencies } = this.obj_dictionaryAdministratorData;
    const selectedMaintenanceAgency = maintenanceAgencies.filter(
      item =>
        item.maintenanceAgency.name ===
        this.obj_createBranchModalData.maintenanceAgencyName
    )[0];

    let projects = selectedMaintenanceAgency.projects.filter(projectItem => {
      return projectItem.project.status !== "CLOSED";
    });

    this.obj_createBranchModalData = {
      ...this.obj_createBranchModalData,
      projects: projects,
      project: projects.length > 1
        ? {
            branches: null,
            project: null,
            framework: null,
            frameworks: null,
          }
        : projects[0],
      projectId: projects.length > 1 ? "" : projects[0].project.tid
    };
  };

  @action
  func_handleBranchNameChange = branchName => {
    this.obj_createBranchModalData = {
      ...this.obj_createBranchModalData,
      branchName: branchName
    };
  };

  @action
  func_handleBranchDescriptionChange = (description) => {
    this.obj_createBranchModalData = {
      ...this.obj_createBranchModalData,
      description: description
    };
  };

  @action
  func_createBranch = () => {
    let jsonToSend = this.func_constructJson();
    this.func_sendRequest(jsonToSend);
    this.func_toggleCreateBranchModalVisibility();
  };

  @computed
  get getMaintenanceAgenciesWithOpenProject() {
    const maintenanceAgenciesWithOpenProject = [];
    const { maintenanceAgencies } = this.obj_dictionaryAdministratorData;
    for(let i = 0; i < maintenanceAgencies.length; i++) {
      for(let j = 0; j < maintenanceAgencies[i].projects.length; j++) {
        if(maintenanceAgencies[i].projects[j].project.status === "OPEN") {
          maintenanceAgenciesWithOpenProject.push(maintenanceAgencies[i]);
          break;
        }
      }
    }
    return maintenanceAgenciesWithOpenProject;
  }

  @action
  func_resetSettings = () => {
    const maintenanceAgenciesWithOpenProject = this.getMaintenanceAgenciesWithOpenProject;
    if(maintenanceAgenciesWithOpenProject.length > 0) {
      if(maintenanceAgenciesWithOpenProject.length > 1) {
        this.obj_createBranchModalData = {
          ...this.obj_createBranchModalData,
          maintenanceAgencyName: "",
          maintenanceAgencyId: "",
          projects: [],
          project: {
            branches: null,
            project: null,
            framework: null,
            frameworks: null,
          },
          projectId: "",
          branchName: "",
          description: "",
        };
      } else {
        this.obj_createBranchModalData = {
          ...this.obj_createBranchModalData,
          maintenanceAgencyName: maintenanceAgenciesWithOpenProject[0].maintenanceAgency.name,
          maintenanceAgencyId: maintenanceAgenciesWithOpenProject[0].maintenanceAgency.tid,
          projects: maintenanceAgenciesWithOpenProject[0].projects.filter(projectItem => {
            return projectItem.project.status !== "CLOSED";
          }),
          project: this.func_getDefaultProject(),
          projectId: this.func_getDefaultProjectId(),
          branchName: "",
          description: "",
        };
      }
    }
  };

  @computed
  get get_obj_dictionaryAdministratorData() {
    return this.obj_dictionaryAdministratorData;
  }

  @computed
  get get_ob_selectedBranchData() {
    let data = {
      projectName: "",
      projectDescription: "",
      projectId: "",
      typeOfProject: "",
      framework: "",
      frameworks: "",
      creationDate: "",
      finalizationDate: "",
      status: "",
      projectOwners: [],
      maintenanceAgency: "",
      maintenanceAgencyId: "",
      maintenanceAgencyOwners: [],
      bid: "",
      branchName: "",
      branchType: "",
      branchStatus: "",
      description: "",
      branchCreationDate: "",
    }
    if (this.selectedBranchData.bid !== "") {
      const selectedBranchMaItem =
        this.obj_dictionaryAdministratorData.maintenanceAgencies.filter(
          maItem => maItem.maintenanceAgency.tid === this.selectedBranchData.mid
        )[0];
      if(!selectedBranchMaItem){
        return data;
      }
      const selectedBranchProjectItem = selectedBranchMaItem.projects.filter(
        projectItem => projectItem.project.tid === this.selectedBranchData.pid
      )[0];
      if(!selectedBranchProjectItem){
        return data;
      }
      const selectedBranchItem = selectedBranchProjectItem.branches.filter(
        branchItem => branchItem.branch.tid === this.selectedBranchData.bid
      )[0];
      if(!selectedBranchItem){
        return data;
      }
      data = {
        projectName: selectedBranchItem.project.name,
        projectDescription: selectedBranchItem.project.description,
        projectId: selectedBranchItem.project.tid,
        typeOfProject: selectedBranchProjectItem.project.projectType,
        framework: selectedBranchProjectItem.framework ? selectedBranchProjectItem.framework.name : "-",
        frameworks: selectedBranchProjectItem.frameworks ? selectedBranchProjectItem.frameworks.map(a => a.name).join(', ') : "-", 
        creationDate: selectedBranchProjectItem.project.creationDate,
        finalizationDate: selectedBranchProjectItem.project.finalizationDate,
        status: selectedBranchProjectItem.project.status,
        projectOwners: selectedBranchItem.projectOwners.length > 0
          ? selectedBranchItem.projectOwners.map(po => ActorUtils.getActorDisplayName(po.name, po.authSystem))
          : ["-"],
        maintenanceAgency: selectedBranchMaItem.maintenanceAgency.name,
        maintenanceAgencyId: selectedBranchMaItem.maintenanceAgency.tid,
        maintenanceAgencyOwners: selectedBranchItem.maintenanceAgencyOwners.length > 0
          ? selectedBranchItem.maintenanceAgencyOwners.map(po => ActorUtils.getActorDisplayName(po.name, po.authSystem))
          : ["-"],
        bid: selectedBranchItem.branch.tid,
        branchName: selectedBranchItem.branch.name,
        branchType: selectedBranchItem.branch.branchType,
        branchStatus: selectedBranchItem.branch.status,
        description: selectedBranchItem.branch.description || "-",
        branchCreationDate: selectedBranchItem.branch.creationDate,
      }
    }
    return data;
  }

  @computed
  get get_obj_listOfChangesInBranchModalData() {
    return this.obj_listOfChangesInBranchModalData;
  }

  @computed
  get get_obj_listOfChangesInBranchData() {
    return this.obj_listOfChangesInBranchData;
  }

  @computed
  get get_allBranchesWithRelatedData() {
    const branches = [];

    // Add "No branch is selected" option
    branches.push(noBranchSelectedBranch);

    if (
      this.obj_dictionaryAdministratorData &&
      this.obj_dictionaryAdministratorData.maintenanceAgencies
    ) {
      this.obj_dictionaryAdministratorData.maintenanceAgencies.forEach(
        (maItem, maIndex) => {
          maItem.projects.forEach((projectItem, projectIndex) => {
            projectItem.branches.forEach((branchItem, branchIndex) => {
              if(branchItem.project.status !== "CLOSED" && branchItem.branch.status !== "INACTIVE") {
                branches.push(branchItem);
              }
            });
          });
        }
      );
    }
    return branches;
  }

  @computed
  get get_bool_showCreateBranchModal() {
    return this.bool_showCreateBranchModal;
  }

  @computed
  get get_obj_createBranchModalData() {
    return this.obj_createBranchModalData;
  }

  @computed
  get get_str_branchNameValidationState() {
    if (this.obj_createBranchModalData.branchName.length > 0) {
      return "success";
    }
    return "error";
  }

  @computed
  get hasDaAnyOpenProject() {
    const { maintenanceAgencies } = this.obj_dictionaryAdministratorData;
    for(let i = 0; i < maintenanceAgencies.length; i++) {
      for(let j = 0; j < maintenanceAgencies[i].projects.length; j++) {
        if(maintenanceAgencies[i].projects[j].project.status === "OPEN") {
          return true;
        }
      }
    }
    return false;
  }
}